import { useState } from 'react';

export function usePdfState() {
  const [pdfUrl, setPdfUrl] = useState<string | undefined>();
  const [isLoading, setIsLoading] = useState(false);

  return { pdfUrl, isLoading, setPdfUrl, setIsLoading };
}
